module.exports = __webpack_public_path__ + "static/assets/88567d730441d9b3793e6fc35e977426.png";